import { render, staticRenderFns } from "./ltiPreviewModal.vue?vue&type=template&id=515c98c8"
import script from "./ltiPreviewModal.vue?vue&type=script&lang=js"
export * from "./ltiPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./ltiPreviewModal.vue?vue&type=style&index=0&id=515c98c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports